import { commonColors, coreThemeColors } from '@youscience/theme';
import { MajorSearchFilters, RecommendationChipData, searchFilters } from '@common-types';

import ChipMarkIcon from '@images/chip-mark.svg?react';
import ChipFolderIcon from '@images/chip-folder.svg?react';
import ChipCertificationIcon from '@images/chip-certifications.svg?react';

export const MAX_CHIPS_WITH_LABEL = 1;

export const RECOMMENDATION_CHIPS_DATA: RecommendationChipData[] = [
  {
    type: 'isBestFitSoc' as keyof MajorSearchFilters,
    icon: <ChipMarkIcon />,
    label: searchFilters.personalRecommendation.fieldLabels.isBestFitSoc,
    color: coreThemeColors.secondary.main,
  },
  {
    type: 'isFavoriteSoc' as keyof MajorSearchFilters,
    icon: <ChipFolderIcon />,
    label: searchFilters.personalRecommendation.fieldLabels.isFavoriteSoc,
    color: coreThemeColors.primary.main,
  },
  {
    type: 'hasCertification' as keyof MajorSearchFilters,
    icon: <ChipCertificationIcon />,
    label: searchFilters.personalRecommendation.fieldLabels.hasCertification,
    color: commonColors.lightBlue,
  },
];
